import store from '@/store';
import { Commit, ActionTree, MutationTree, Dispatch } from 'vuex';

import rootStateStore, { State } from './apmCommonState.store';

// Utility function
// const concatOption = (data: any) => {
//   const isLog: boolean = router.app.$route.fullPath === '/log';
//   return isLog ? [{ label: 'All', key: '' }].concat(data) : data;
// };

const mutations: MutationTree<State> = {
  // Sets the services in rootState
  setServices(state: State, data: any) {
    // data = concatOption(data);
    // window.localStorage.setItem('services', data);
    state.services = data;
  },
  //Sets the current service in rootState
  setCurrentService(state: State, service: any) {
    state.currentService = service;
    store.commit('globalState/app/setUpdateDasboard', service, { root: true });
    // state.updateDashboard = service;
  },

  setCurrentSubType(state: State, subtype: any) {
    state.subtype = subtype;
  },
  // Sets the endpoints in the rootState
  setEndpoints(state: State, data: any) {
    // data = concatOption(data);
    state.endpoints = data;
    if (!data.length) {
      state.currentEndpoint = {};
      return;
    }
    if (
      (!state.currentEndpoint.key && data.length) ||
      !state.endpoints.some(ep => {
        return (
          ep.key === state.currentEndpoint.key &&
          ep.label === state.currentEndpoint.label
        );
      })
    ) {
      state.currentEndpoint = data[0];
    }
  },
  //Sets the currentEndpoint in rootState
  setCurrentEndpoint(state: State, endpoint: any) {
    state.currentEndpoint = endpoint;
    store.commit('globalState/app/setUpdateDasboard', endpoint, { root: true });
    // state.updateDashboard = endpoint;
  },
  //Sets the insatacnes in rootState
  setInstances(state: State, data: any) {
    // data = concatOption(data);
    state.instances = data;
    if (!data.length) {
      state.currentInstance = {};
      return;
    }
    if (
      (!state.currentInstance.key && data.length) ||
      !state.instances.some(inst => {
        return (
          inst.key === state.currentInstance.key &&
          inst.label === state.currentInstance.label
        );
      })
    ) {
      state.currentInstance = data[0];
    }
  },
  //sets the currrentInstance in the rootState
  setCurrentInstance(state: State, instance: any) {
    state.currentInstance = instance;
    store.commit('globalState/app/setUpdateDasboard', instance, { root: true });
    // state.updateDashboard = instance;
  },
  //sets language for current Service/Application
  setCurrentServiceLanguage(state: State, data: any) {
    state.currentServiceLanguage = data;
  },
  // Sets the databases in the rootState
  setDatabases(state: State, data: any) {
    state.databaseServices = data;
    if (!data.length) {
      state.currentDatabaseService = {};
      return;
    }
    if (
      (!state.currentDatabaseService.key && data.length) ||
      !state.databaseServices.includes(state.currentDatabaseService)
    ) {
      state.currentDatabaseService = data[0];
      store.commit(
        'globalState/app/setUpdateDasboard',
        state.currentDatabaseService,
        { root: true }
      );
      // state.updateDashboard = state.currentDatabaseService;
    }
  },
  // Sets the currentDatabase in the rootState
  setCurrentDatabase(state: State, service: any) {
    state.currentDatabaseService = service;
    store.commit('globalState/app/setUpdateDasboard', service, { root: true });
    // state.updateDashboard = service;
  },
  setCurrentServiceApdex(state: State, apdexval: any) {
    state.currentServiceApdex = apdexval;
  },
  setSaveAllErrors(state: State, saveErrors: any) {
    state.saveAllErrorTraces = saveErrors;
  },
  setMinTraceLatency(state: State, traceLatency: any) {
    state.minTraceLatency = traceLatency;
  },
  setMaxSpansPerTraces(state: State, maxSpansVal: any) {
    state.maxSpansPerTraces = maxSpansVal;
  },
  setMinDbQueryLatency(state: State, queryLatency: any) {
    state.minDbQueryLatency = queryLatency;
  },

  // resets to default values on logout
  setDefaultValues(state: State, value: any) {
    state.capability = '';
    state.subtype = '';
    state.services = [];
    state.instances = [];
    state.endpoints = [];
    state.databaseServices = [];
    state.currentService = {};
    state.currentEndpoint = {};
    state.currentInstance = {};
    state.currentDatabaseService = {};
    state.updateDashboard = {};
    state.currentServiceApdex = 0;
    state.currentServiceLanguage = '';
  }
};

export default mutations;
